import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'commaSeparator'
})
export class CommaSeparatorPipe implements PipeTransform {
  transform(x): string {
    if (x == '0' || x == '0.00' || x == '.00' || x == '.0') {
      return '0.00';
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
